import api from "./axiosInstance";

/**
 * Settings → Integrations APIs for lead providers (IndiaMART / TradeIndia).
 * Credentials travel only inside request bodies (never URLs) and are masked
 * by the backend in every response.
 */
export const leadIntegrationApi = {
  list: () => api.get("/integrations/lead-providers"),
  getSettings: (provider) => api.get(`/integrations/lead-providers/${provider}/settings`),
  saveSettings: (provider, data) => api.put(`/integrations/lead-providers/${provider}/settings`, data),
  verify: (provider, data) => api.post(`/integrations/lead-providers/${provider}/verify`, data || {}),
  sync: (provider) => api.post(`/integrations/lead-providers/${provider}/sync`),
  getSyncLogs: (provider, params = {}) =>
    api.get(`/integrations/lead-providers/${provider}/sync-logs`, { params }),
  retryFailed: (provider, logId) =>
    api.post(`/integrations/lead-providers/${provider}/retry-failed`, null, {
      params: logId ? { logId } : {},
    }),
  disconnect: (provider) => api.post(`/integrations/lead-providers/${provider}/disconnect`),
};

export default leadIntegrationApi;
